export function buildWishlistSectionLogin(href, origin, route, path, anchor, previewTheme, storeOrigin = origin) {
  try {
    const current = new URL(href, origin);
    const store = new URL(storeOrigin);
    if (store.protocol !== 'https:' || store.username || store.password || store.pathname !== '/' || store.search || store.hash) return null;
    const login = new URL(route, store.origin);
    if (current.origin !== origin || current.pathname !== path || current.username || current.password ||
        !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/[a-z0-9_-]+\/?$/i.test(path) ||
        login.origin !== store.origin || login.username || login.password ||
        !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?customer_authentication\/login$/i.test(login.pathname) ||
        !/^[a-z0-9_-]+$/i.test(anchor)) return null;
    current.searchParams.delete('sc_wishlist_return');
    if (previewTheme) {
      if (!/^\d{1,20}$/.test(previewTheme)) return null;
      current.searchParams.set('preview_theme_id', previewTheme);
    }
    current.hash = anchor;
    login.searchParams.set('return_to', current.pathname + current.search + current.hash);
    return store.origin === origin ? login.pathname + login.search : login.href;
  } catch {
    return null;
  }
}

export function bindWishlistSection(section, browser) {
  const link = section.querySelector('[data-bf-wishlist-login]');
  if (!link || link.dataset.bfWishlistBound) return;
  link.dataset.bfWishlistBound = 'true';
  const update = () => {
    const href = buildWishlistSectionLogin(browser.location.href, browser.location.origin,
      section.dataset.bfLoginRoute, section.dataset.bfReturnPath, section.id,
      section.dataset.bfPreviewTheme, section.dataset.bfStoreOrigin);
    if (href) link.setAttribute('href', href);
  };
  update();
  link.addEventListener('click', update);
  browser.addEventListener('pageshow', update);
  browser.addEventListener('hashchange', update);
}

if (typeof document !== 'undefined') {
  const bind = () => document.querySelectorAll('[data-bf-wishlist-account]').forEach(section => {
    bindWishlistSection(section, window);
  });
  bind();
  document.addEventListener('shopify:section:load', bind);
}
